<template>
  <div class="flex-1 px-4 py-10 text-center">
    <img src="@/images/logo.png" class="mx-auto">
    <h3 class="mt-3 text-3xl font-catamaran">Uzhavarbumi<sup><small>®</small></sup></h3>
    <h2 class="mb-5 text-xl">Dealer Portal</h2>

    <div class="max-w-xs py-8 mx-auto">
      <div>
        <div class="flex items-center px-3 py-2 bg-white rounded-lg shadow">
          <input v-model="form.phone" :disabled="state == 'otp'" type="number" class="text-3xl max-w-[200px] focus:outline-none placeholder:text-lg disabled:bg-white" placeholder="Phone Number"/>
          <button @click="getOtp" class="flex-grow py-2 text-right text-slate-600">GET OTP</button>
        </div>
        <p class="w-full mt-1 text-left text-red-300" v-if="errors.phone">{{ errors.phone }}</p>
      </div>

      <div v-if="state == 'otp'" class='mt-3'>
        <div class="flex items-center px-3 py-2 bg-white rounded-lg shadow">
          <input v-model="form.otp" ref="inputOtp" type="number" class="w-full text-3xl focus:outline-none placeholder:text-lg" placeholder="Enter OTP from Phone"/>
        </div>
        <p class="w-full mt-1 text-left text-red-300" v-if="errors.otp">{{ errors.otp }}</p>
      </div>

      <div v-if="state == 'otp'">
        <button class="px-4 py-1 mt-4 text-gray-100 uppercase rounded-full bg-slate-700" @click="login">Login</button>
      </div>
    </div>

    <div class="max-w-xs m-auto mt-5">
      <p>If you are a Customer, please use our <a class="underline" target="_blank" href="https://play.google.com/store/apps/details?id=com.uzhavarbumi.app">Customer app</a></p>
      <p class="mt-5">Want to know more about us, visit <a target="_blank" class="underline" href="https://uzhavarbumi.com">Uzhavarbumi.com</a></p>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import formMixin from '@/utils/mixins/form.js';

export default {
  name: 'Login',
  mixins: [ mixin, formMixin ],

  data() {
    return {
      state: 'login',
      form: { phone: null, otp: null },
      lastOtpTime: null
    }
  },

  methods: {
    getOtp() {
      const now = Date.now();
      const oneMinutes = 1 * 60 * 1000;

      if (this.lastOtpTime && now - this.lastOtpTime < oneMinutes) {
        alert('Please wait 1 minute before requesting OTP again.');
        return;
      }

      this.lastOtpTime = now;

      if (!this.validateForm(this.form, {phone: 'required|numeric|length:10'})) return;

      this.request('POST', 'getOtp', this.form, (resp) => {
        if (resp.success) {
          this.state = 'otp';
          this.$nextTick(() => this.$refs.inputOtp.focus());
        } else {
          alert(resp.message ? resp.message : 'Sorry, please try again.');
        }
      });
    },

    login() {
      if (!this.validateForm(this.form, {otp: 'required|numeric|length:6'})) return;

      this.request('POST', 'login', this.form, (resp) => {
        if (resp.success) {
          window.localStorage.setItem('dealer_api_token', resp.data.api_token)
          this.$store.state.api_token = resp.data.api_token;

          if (window.localStorage.getItem('dealer_logins') != null) {
            let logins = JSON.parse(window.localStorage.getItem('dealer_logins'));
            if (logins.filter(l => l.id == resp.data.id).length == 0) {
              logins.push(resp.data);
              window.localStorage.setItem('dealer_logins', JSON.stringify(logins));
            }
          } else {
            window.localStorage.setItem('dealer_logins', JSON.stringify([resp.data]));
          }

          this.$router.push({name: 'Dashboard'});
        } else {
          alert(resp.message ? resp.message : 'Unable to login, please try again.');
        }
      });
    },
  },

  created() {
    if (window.localStorage.getItem('dealer_user') && window.localStorage.getItem('dealer_api_token')) {
      this.$store.state.user = JSON.parse(window.localStorage.getItem('dealer_user'));
      this.$store.state.api_token = window.localStorage.getItem('dealer_api_token');
      this.$router.push({name: 'Dashboard'});
    }
  }
}
</script>
